var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M9.06 12l5.47-5.47a.75.75 0 00-1.06-1.06l-6 6c-.3.3-.3.77 0 1.06l6 6a.75.75 0 001.06-1.06L9.06 12z"}})}
var staticRenderFns = []

export { render, staticRenderFns }